import { render, staticRenderFns } from "./scienceJqList.vue?vue&type=template&id=e6664f00&scoped=true&"
import script from "./scienceJqList.vue?vue&type=script&lang=js&"
export * from "./scienceJqList.vue?vue&type=script&lang=js&"
import style0 from "./scienceJqList.vue?vue&type=style&index=0&id=e6664f00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6664f00",
  null
  
)

component.options.__file = "scienceJqList.vue"
export default component.exports